export default __webpack_public_path__ + "img/effbc4728437b9ad5853516386583e95.png";